import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router';

import { Button } from '@xsolla/ui-core';
import { ChevronRightMini } from '@xsolla/ui-icons';

import { useCurrentProject } from '../../../contexts/settings';
import { usePaths } from '../../../routes/routesHelper';
import { RouteParams } from '../../../routes/types';
import { NavigationWrapper } from '../../ui';

type Props = React.PropsWithChildren<RouteComponentProps>;

const CustomProviderTabs = ({ match, children, location }: Props): JSX.Element => {
  const { dashboardPath, emailCustomProviderPath, navigationPath, smsCustomProviderPath } =
    usePaths();
  const { projectId } = match.params as RouteParams;
  const intl = useIntl();
  const { currentProject } = useCurrentProject(projectId);

  const tabItems = [
    {
      label: intl.formatMessage({ id: 'custom-providers.tabs.email' }),
      href: emailCustomProviderPath(projectId)
    },
    {
      label: intl.formatMessage({ id: 'custom-providers.tabs.sms' }),
      href: smsCustomProviderPath(projectId)
    }
  ];

  const breadCrumbsOptions = [
    {
      label: intl.messages['dashboard.label'],
      to: dashboardPath()
    },
    {
      label: currentProject?.name,
      to: navigationPath(projectId)
    },
    {
      label: intl.messages['custom-providers.bread-crumbs.label'],
      to: `#`
    }
  ];

  return (
    <NavigationWrapper
      rightTabsContent={
        // eslint-disable-next-line react/jsx-wrap-multilines
        <Button look="link" palette="brand" size="md" disabled>
          <ChevronRightMini />
          {intl.formatMessage({
            id: `custom-providers.tabs.send-${
              location.pathname === emailCustomProviderPath(projectId) ? 'email' : 'sms'
            }.button`
          })}
        </Button>
      }
      breadCrumbsOptions={breadCrumbsOptions}
      tabsItems={tabItems}
      dataTestId="custom-provider">
      {children}
    </NavigationWrapper>
  );
};

export default withRouter(CustomProviderTabs);
